export default "__VITE_ASSET__Cv0WoVe9__"